import React from "react";
import { StatsCardCurrency, StatsCardDefault } from "./IndividualComponents";
import {
  Typography,
  Button,
  Input,
  Row,
  Col,
  Card,
  Space,
  Empty,
  Divider,
  Statistic,
} from "antd";
import {
  SearchOutlined,
  UserOutlined,
  FileTextOutlined,
  DollarOutlined,
  ClusterOutlined,
  BarsOutlined,
  GlobalOutlined,
  StockOutlined,
} from "@ant-design/icons";
const { Text } = Typography;

export const RecordDetails = (props) => {
  const { record } = props;
  return (
    <div className="p-2">
      <h4>
        <Text mark>
          <ClusterOutlined className="mr-2" />
          Org
        </Text>
      </h4>
      <h3>
        <Text>{record["Company Name In Myanmar"]}</Text>
      </h3>
      <p>
        <BarsOutlined className="mr-2" />
        Type Of Investment Business
        <br />
        {record["Type Of Investment Business"]}
      </p>
      <p>
        <GlobalOutlined className="mr-2" />
        Investment Permitted Address
        <br />
        {record["Investment Permitted Address"]}
      </p>
      <Space wrap={true}>
        <Statistic
          title="Type Of Investment"
          value={record["Type Of Investment"]}
        />
        <Statistic
          title="Investing Country"
          value={record["Investing Country"]}
        />
        <Statistic
          title="Sector"
          valueStyle={
            record["Sector"] ? { color: "#0078d8" } : { color: "#cf1322" }
          }
          value={record["Sector"] || "Unknown"}
        />
        <StatsCardDefault record={record} field={"Form Of Investment"} />
      </Space>
      <Divider />
      <h4>
        <Text mark>
          <UserOutlined className="mr-2" />
          People
        </Text>
      </h4>
      <Space wrap={true}>
        {/* <Card className="individual-result-card">
              <h5 className="">Name Of Investor</h5>
              <p className="">{record["Name Of Investor"]}</p>
            </Card> */}
        <Statistic
          title="Name Of Investor"
          value={record["Name Of Investor"]}
        />
        <Statistic
          title="Number Of Local Employees"
          valueStyle={
            record["Number Of Local Employees"]
              ? { color: "#3f8600" }
              : { color: "#cf1322" }
          }
          value={record["Number Of Local Employees"] || "Unknown"}
        />
        <Statistic
          title="Number Of Foreign Employees"
          valueStyle={
            record["Number Of Foreign Employees"]
              ? { color: "#3f8600" }
              : { color: "#cf1322" }
          }
          value={record["Number Of Foreign Employees"] || "Unknown"}
        />
        <Statistic title="Land Owner" value={record["Land Owner"]} />
      </Space>
      <Divider />
      <h4>
        <Text mark>
          <DollarOutlined className="mr-2" />
          Money
        </Text>
      </h4>
      <Space wrap={true}>
        <StatsCardCurrency
          record={record}
          field={"Total Amount Of Capital (in Millions)"}
        />
        <StatsCardCurrency
          record={record}
          field={"Amount Of Foreign Capital USD (in Millions)"}
        />
        <StatsCardCurrency record={record} field={"Annual Lease Fee"} />
        <StatsCardCurrency record={record} field={"Land Use Premium"} />
      </Space>
      <Divider />
      <h4>
        <Text mark>
          <StockOutlined className="mr-2" />
          Investment / Miscellaneous
        </Text>
      </h4>
      <Space wrap={true}>
        <Statistic
          title="Name of Principal Organization"
          value={record["Name of Principal Organization"] || "Unknown"}
          precision={2}
          valueStyle={
            record["Name of Principal Organization"] ? {} : { color: "#cf1322" }
          }
        />
        <StatsCardDefault record={record} field={"Place of Incorporation"} />
        <StatsCardDefault
          groupSeparator={""}
          record={record}
          field={"Financial Year From"}
        />
        <StatsCardDefault
          groupSeparator={""}
          record={record}
          field={"Financial Year To"}
        />
        <StatsCardDefault
          groupSeparator={""}
          record={record}
          field={"Period For Bringing in Foreign Capital (in years)"}
        />
        <StatsCardDefault
          groupSeparator={""}
          record={record}
          field={"Validity Of Investment Permit (in Years)"}
        />
        <StatsCardDefault record={record} field={"Permit Number"} />
        <StatsCardDefault record={record} field={"Meeting Number"} />
        <StatsCardDefault record={record} field={"Meeting Date"} />
        <StatsCardDefault
          record={record}
          field={"Land Area (units not specified in file)"}
        />{" "}
        <StatsCardDefault record={record} field={"Lease Term"} />
        <StatsCardDefault record={record} field={"Status"} />
        <StatsCardDefault record={record} field={"Investor Address"} />
        <StatsCardDefault record={record} field={"Organization Address"} />
      </Space>
    </div>
  );
};
